export default __webpack_public_path__ + "static/media/hair-cut.ed912f13.jpg";